const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
// Api key insertion file
export const mapOptions = {
  googleMapApiKey: "AIzaSyCspKA-cNtMjWkgVmTDg6LL7eK8EQx6muY",
};
